export default "__VITE_ASSET__Cx$$RT6___"